import { INotificationAPI } from '../queries';
import MCPMarketEnvironmentDetection, {
  MCP_MARKET_ENVIRONMENT_COUNTRY_CODES,
} from '../utils/market-environment-detection';
import HttpClient from './base/http-client';

class NotificationAPIService extends HttpClient {
  constructor(baseURL: string, authHeaderName: string) {
    super(baseURL, authHeaderName);
  }

  public getNotifications = (): Promise<INotificationAPI[]> => {
    return this.instance.get('/notifications');
  };

  public setNotificationReadStatus = (notificationIds: string[]): Promise<string> => {
    return this.instance.put('/notifications', {
      notificationIds,
    });
  };
}

const getBaseUrl = () => {
  const { countryCode } = MCPMarketEnvironmentDetection.getMarketEnvironment();
  if (countryCode === MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.UK) {
    return process.env.AUTH_API_URL_EU_WEST as string;
  }
  return process.env.AUTH_API_URL_EU_CENTRAL as string;
};

export default new NotificationAPIService(getBaseUrl(), 'X-Auth');
